import { render, staticRenderFns } from "./DataLoading.vue?vue&type=template&id=51e8d90f&"
import script from "./DataLoading.vue?vue&type=script&lang=js&"
export * from "./DataLoading.vue?vue&type=script&lang=js&"
import style0 from "./DataLoading.vue?vue&type=style&index=0&id=51e8d90f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports